var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Helper } from '../../classes/helper';
import { User } from '../../classes/user';
import { UserService } from '../../services/user.service';
import { LoginService } from '../../services/login.service';
import { HasSubscriptions } from '../../components/has-subscriptions';
import { CustomValidators } from '../../classes/custom-validators';
import { CommunicationService } from '../../services/communication.service';
import { SCREEN_SIZE } from '../../classes/enums';
import { PreRenderService } from '../../services/pre-render.service';
var MyAccountComponent = /** @class */ (function (_super) {
    __extends(MyAccountComponent, _super);
    function MyAccountComponent(userService, loginService, route, prerenderService, communicationService, formBuilder) {
        var _this = _super.call(this) || this;
        _this.userService = userService;
        _this.loginService = loginService;
        _this.route = route;
        _this.prerenderService = prerenderService;
        _this.communicationService = communicationService;
        _this.formBuilder = formBuilder;
        _this.toggleEditPassword = false;
        _this.showPasswordText = false;
        _this.showConfirmPasswordText = false;
        _this.languageOptions = [
            {
                text: 'English',
                value: 'English'
            },
            {
                text: 'French',
                value: 'french'
            }
        ];
        _this.SCREEN_SIZE = SCREEN_SIZE;
        _this.accountForm = _this.formBuilder.group({
            email: [{ value: '', disabled: true }],
            profile: _this.formBuilder.group({
                name: [''],
                phoneNumber: '',
                language: _this.languageOptions[0].value,
                buy: false,
                sell: false,
            }),
            password: _this.formBuilder.group({
                password: ['', [Validators.min(6)]],
                confirmPassword: ['', [Validators.min(6)]]
            }, { validator: CustomValidators.passwordMatcher })
        });
        return _this;
    }
    MyAccountComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.userService.currentUser.subscribe(function (user) {
            // TODO: we probably should do something here if they;re not signed in
            _this.prerenderService.setPreRenderFlag(200);
            _this.user = user;
            _this.accountForm.controls['email'].setValue(_this.user.email);
            var profileFormGroup = _this.accountForm.controls['profile'];
            profileFormGroup.get('phoneNumber').setValue(Helper.formatPhoneNumber(_this.user.phoneNumber));
            profileFormGroup.get('name').setValue(_this.user.name);
            profileFormGroup.get('language').setValue(_this.user.language);
            profileFormGroup.get('buy').setValue(_this.user.buy);
            profileFormGroup.get('sell').setValue(_this.user.sell);
        }));
        this.addSub(this.communicationService.screenSize.subscribe(function (screenSize) {
            _this.screenSize = screenSize;
        }));
    };
    MyAccountComponent.prototype.onSubmit = function () {
        var _this = this;
        var newUser = new User(this.user);
        var profileFormGroup = this.accountForm.controls['profile'];
        newUser.phoneNumber = profileFormGroup.get('phoneNumber').value;
        newUser.name = profileFormGroup.get('name').value;
        newUser.buy = profileFormGroup.get('buy').value;
        newUser.sell = profileFormGroup.get('sell').value;
        newUser.language = profileFormGroup.get('language').value;
        if (this.toggleEditPassword) {
            this.loginService.changePasswordWhileLoggedIn(this.accountForm.value.password.password.value);
        }
        // TODO: navigate to where they were
        this.userService.saveUser(newUser).then(function (s) {
            _this.route.navigate(['/find-real-estate']);
        });
    };
    Object.defineProperty(MyAccountComponent.prototype, "passwordFormGroup", {
        get: function () {
            return this.accountForm.get('password');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MyAccountComponent.prototype, "password", {
        get: function () {
            return this.passwordFormGroup.get('password');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MyAccountComponent.prototype, "confirmPassword", {
        get: function () {
            return this.passwordFormGroup.get('confirmPassword');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MyAccountComponent.prototype, "profileFormGroup", {
        get: function () {
            return this.accountForm.get('profile');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MyAccountComponent.prototype, "name", {
        get: function () {
            return this.profileFormGroup.get('name');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MyAccountComponent.prototype, "email", {
        get: function () {
            return this.accountForm.get('email');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MyAccountComponent.prototype, "phoneNumber", {
        get: function () {
            return this.profileFormGroup.get('phoneNumber');
        },
        enumerable: true,
        configurable: true
    });
    return MyAccountComponent;
}(HasSubscriptions));
export { MyAccountComponent };
